module.exports = __webpack_public_path__ + "static/media/icon2.c60084e8.webp";